module.exports = __webpack_public_path__ + "img/foodqo-icon-white.82805e48.svg";